/**
 * buildRateLookup
 *
 * Builds a `(staffId) => hourlyRate` function from staff + position-rates
 * data -- the same "staff's position, then that position's latest
 * effective rate" join used across every page that costs out SSS
 * scheduled hours or TRS actual hours. Centralized here since this exact
 * pattern was being reimplemented per-page.
 * @param {any[]} staff
 * @param {any[]} positionRates
 */
export function buildRateLookup(staff, positionRates) {
  const staffById = new Map(staff.map((s) => [String(s.id), s]));

  const latestRateByPosition = new Map();
  [...positionRates]
    .sort((a, b) => new Date(a.effective_date) - new Date(b.effective_date))
    .forEach((r) => latestRateByPosition.set(r.position_title, Number(r.hourly_rate)));

  /** @param {string} staffId */
  return (staffId) => {
    const position = staffById.get(String(staffId))?.position;
    return position ? (latestRateByPosition.get(position) ?? 0) : 0;
  };
}
